class CollectionUpsellSlider extends HTMLElement {
  connectedCallback() {
    this.initWhenReady();
  }

  initWhenReady() {
    if (typeof Splide === 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initWhenReady());
      } else {
        // Splide script may still be loading; poll briefly
        const check = () => {
          if (typeof Splide !== 'undefined') {
            this.init();
          } else {
            requestAnimationFrame(check);
          }
        };
        requestAnimationFrame(check);
      }
      return;
    }
    this.init();
  }

  init() {
    const el = this.querySelector('.splide');
    if (!el || this.splide) return;

    this.splide = new Splide(el, {
      type: 'slide',
      perPage: 3,
      gap: '8px',
      // Splide's Controller reads omitEnd once at construction, so it cannot be
      // set from a breakpoint — it has to live here even though only the
      // one-per-slide mobile pagination needs it.
      omitEnd: true,
      pagination: true,
      arrows: false,
      drag: true,
      classes: {
        pagination: 'splide__pagination collection-upsell__dots',
        page: 'splide__pagination__page collection-upsell__dot',
      },
      breakpoints: {
        749: {
          perPage: 1,
          fixedWidth: '144px',
          padding: { left: '1.5rem', right: '1.5rem' },
          // Pairs with omitEnd: only with focus set does Splide drop the trailing
          // dots that trimSpace collapses onto the last scroll position.
          focus: 0,
        },
      },
    });
    this.splide.mount();

    // Ensure inactive dots have aria-selected="false" (WCAG 4.1.2)
    const setAriaSelected = () => {
      el.querySelectorAll('.collection-upsell__dot[role="tab"]').forEach(dot => {
        if (dot.getAttribute('aria-selected') !== 'true') {
          dot.setAttribute('aria-selected', 'false');
        }
      });
    };
    setAriaSelected();
    this.splide.on('moved', setAriaSelected);
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
customElements.define('collection-upsell-slider', CollectionUpsellSlider);
